import { forwardRef } from "react";
import { useField } from "formik";

const CustomTextArea = forwardRef((
  {
    label,
    className = "",
    showAstreisk = true,
    layout = "stacked",
    height = "100px",
    labelWidth = {},
    ...props
  },
  ref
) => {
  const [field, meta] = useField(props);

  const inputClassName =
    `custom-primary-input ${className} ${meta.touched && meta.error ? "custom-input-error" : ""} `.trim();

  const getResponsiveGap = () => {
    return {
      "--label-width-mobile": labelWidth?.mobile || "100px",
      "--label-width-tablet": labelWidth?.tablet || "100px",
      "--label-width-desktop": labelWidth?.desktop || "100px",
    };
  };

  return (
    <>
      <div
        className={`custom-input-group ${layout === "inline" ? "inline-layout" : ""}`}
        style={layout === "inline" ? getResponsiveGap() : {}}
      >
        <div className="label-container">
          <label>{label} {showAstreisk && "*"}</label>
        </div>
        <div style={{ flex: layout === "inline" ? 1 : "unset" }}>
          <textarea
            {...field}
            {...props}
            ref={ref}
            className={inputClassName}
            style={{ height }}
          />
          {meta.touched && meta.error && (
            <div className="custom-error">{meta.error}</div>
          )}
        </div>
      </div>
    </>
  );
});

export default CustomTextArea;
